<div style="padding: 20px;">
  <div class="table-card">
    <div class="table-header">
      <h2 class="table-title">{{ formatText(subMenu) }}</h2>
      <mat-form-field appearance="outline" class="custom-seash-input">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" [placeholder]="formatText(subMenu)" />
      </mat-form-field>
      <button mat-flat-button color="primary" class="reset-btn" (click)="ExportTOExcel()" [disabled]="count == 0">Export
        As Excel</button>
    </div>
    <mat-divider style="margin-bottom: 10px;"></mat-divider>
    <table mat-table matSort [dataSource]="dataSource" class="workorder-table">
      <ng-container matColumnDef="WorkOrderType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Work Order Type</th>
        <td mat-cell *matCellDef="let report">
          {{ report.WorkOrderType }}
        </td>
      </ng-container>
      <ng-container matColumnDef="ImprovementType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Improvement Type</th>
        <td mat-cell *matCellDef="let report">
          {{ report.ImprovementType }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Manufacturer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Manufacturer</th>
        <td mat-cell *matCellDef="let report">
          {{ report.Manufacturer }}
        </td>
      </ng-container>
      <ng-container matColumnDef="ModelNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Model Number</th>
        <td mat-cell *matCellDef="let report">
          {{ report.ModelNumber }}
        </td>
      </ng-container>
      <ng-container matColumnDef="ESID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ES ID</th>
        <td mat-cell *matCellDef="let report">
          {{ report.ES_ID }}
        </td>
      </ng-container>
      <ng-container matColumnDef="ExternalKey">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>External Key</th>
        <td mat-cell *matCellDef="let report">
          {{ report.ExternalKey }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Capacity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Capacity</th>
        <td mat-cell *matCellDef="let report">
          {{ report.Capacity }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <ng-container *ngIf="count == 0 || dataSource?.data.length === 0">
      <div class="no-records">No records found.</div>
    </ng-container>
    <mat-paginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>
  </div>
</div>